import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

const TitleWrapper = styled(Box)(({ theme, align = 'center' }) => ({
  textAlign: align,
  marginBottom: theme.spacing(6),
  maxWidth: align === 'center' ? '800px' : '100%',
  marginLeft: align === 'center' ? 'auto' : 0,
  marginRight: align === 'center' ? 'auto' : 0,

  [theme.breakpoints.down('md')]: {
    marginBottom: theme.spacing(4),
  },
}));

const GradientText = styled('span')(({ theme }) => ({
  background: theme.palette.accent.gradient,
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  backgroundClip: 'text',
}));

export default function SectionTitle({
  title,
  subtitle,
  align = 'center',
  light = false,
  highlightText,
  sx = {},
}) {
  const renderTitle = () => {
    if (highlightText && title.includes(highlightText)) {
      const parts = title.split(highlightText);
      return (
        <>
          {parts[0]}
          <GradientText>{highlightText}</GradientText>
          {parts[1]}
        </>
      );
    }
    return title;
  };

  return (
    <TitleWrapper align={align} sx={sx}>
      <Typography
        variant="h2"
        component="h2"
        sx={{
          mb: 2,
          color: light ? 'text.light' : 'text.primary',
          fontWeight: 700,
        }}
      >
        {renderTitle()}
      </Typography>

      {subtitle && (
        <Typography
          variant="body1"
          sx={{
            color: light ? 'rgba(255, 255, 255, 0.8)' : 'text.secondary',
            maxWidth: '600px',
            mx: align === 'center' ? 'auto' : 0,
            fontSize: '1.125rem',
            lineHeight: 1.7,
          }}
        >
          {subtitle}
        </Typography>
      )}
    </TitleWrapper>
  );
}
